import React, { FC } from 'react';
import { isEditorActive, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { TCHSeriesDetailNavigationSectionProps } from './types/productSeriesDetailNavigationOverviewSection.types';
import { CHSeriesDetailNavigationSectionModel } from './models/productSeriesDetailNavigationOverviewSection.model';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import { targetLinkdsk } from '../../utils/targetDskLink';
import useMediaQuery from '../../lib/custom-hooks/useMediaQuery';
import { BreakpointsInPx } from '../../constants/breakpoints.constants';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import RoutableNotEditableLink from '../@shared/routableNotEditableLink';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { googleClickNavEvent } from '../../utils/analytics';
import IconOrImage from '../@shared/iconOrImage';
import { appendRootToInternalLink } from '../../utils/appendRootToInternalLink.utils';

const ProductSeriesDetailNavigationOverview: FC<TCHSeriesDetailNavigationSectionProps> = (props) => {
  const apiResponse =
    isEmptyResponse(props) && props?.fields?.apiData?.innerComponents && props?.fields?.apiData?.innerComponents?.length > 0;
  const model = new CHSeriesDetailNavigationSectionModel(props);
  const isPlaceholderShown = useExperiencerEditorPlaceholder(props);
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return <ExperienceEditorComponentPlaceholder image={model.thumbnailEE} componentName={model.componentName} />;
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={model.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  return (
    <div className="product-series-detail-navigation-overview" style={{ backgroundColor: model.backgroundColor || '#f4f4f4' }}>
      {model.innerComponents.map(
        ({ button, assets }, index) =>
          button &&
          button?.label &&
          button.url && (
            <div key={index} className="product-series-detail-navigation-overview__cta-wrapper">
              <RoutableNotEditableLink
                href={appendRootToInternalLink(button.url)}
                target={targetLinkdsk({ value: { href: button?.url, target: button?.target } }, isDesktop)}
                onClick={() => googleClickNavEvent('Page Sub Nav', button?.label, 'Series Overview Nav Bar')}
              >
                <div className="product-series-detail-navigation-overview__cta-icon-wrapper">
                  <IconOrImage assets={assets} />
                </div>
                <Text
                  editable={false}
                  field={{ value: button.label }}
                  tag="p"
                  className="product-series-detail-navigation-overview__cta-label"
                />
              </RoutableNotEditableLink>
            </div>
          )
      )}
    </div>
  );
};

export default withSitecoreContext()(ProductSeriesDetailNavigationOverview);
